/**
 * Точка входа в API: готовые клиенты поверх общего axios-инстанса.
 *
 * Сами клиенты в clients/ сгенерированы из swagger бэкенда (tool/generate_api_clients.sh)
 * и руками не правятся. Здесь они только связываются с http: локаль, токен и
 * обновление сессии живут там, и дублировать это в каждом клиенте незачем.
 */
import { PageServiceApi } from './clients/knowledge-page'
import { SpaceServiceApi } from './clients/knowledge-space'
import { GitLabServiceApi, DevOpsServiceApi } from './clients/tracker-gitlab'
import { IssueServiceApi } from './clients/tracker-issue'
import { ProjectServiceApi } from './clients/tracker-project'
import { http } from './http'

// Хост берётся из того же места, что и baseURL самого axios: клиент
// подставляет его в путь, а axios — в запрос, и разойтись они не должны.
const basePath = import.meta.env.VITE_API_BASE_URL || ''

export const issueApi = new IssueServiceApi(undefined, basePath, http)
export const projectApi = new ProjectServiceApi(undefined, basePath, http)
export const gitlabApi = new GitLabServiceApi(undefined, basePath, http)
export const devopsApi = new DevOpsServiceApi(undefined, basePath, http)

// База знаний — отдельный сервис knowledge со своим префиксом /api/v1/knowledge,
// но тот же вход и та же сессия, поэтому и axios общий.
export const pageApi = new PageServiceApi(undefined, basePath, http)
export const spaceApi = new SpaceServiceApi(undefined, basePath, http)

export { http } from './http'
